document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.announcement-slider-list');
    const slides = document.querySelectorAll('.announcement-slide');
    const prevBtn = document.querySelector('.announ-button--prev');
    const nextBtn = document.querySelector('.announ-button--next');
    const autoPlayDuration = slider.getAttribute('data-delay')*1000;
    let currentIndex = 0;


    if (!slider || slides.length <= 1) return;

    slides.forEach((slide) => {
        slide.style.transition = 'opacity 0.6s ease-in-out';
        slide.style.opacity = 0;
    });


    slider.style.position = 'relative';
    slider.style.display = 'flex';
    slider.style.flexDirection = 'column';

    let maxHeight = 0;
    slides.forEach((slide) => {
        const slideHeight = slide.querySelector('.announcement-bar__message').scrollHeight;
        if (slideHeight > maxHeight) maxHeight = slideHeight;
    });
    slider.style.height = maxHeight + 'px';


    function updateSlides(index) {
        slides.forEach((slide, i) => {
            if (i === index) {
                slide.classList.add('active');
                slide.style.opacity = 1;
                slide.style.zIndex = 1;
                slide.style.pointerEvents = 'auto';
                slide.style.height = 'auto';
            } else {
                slide.classList.remove('active');
                slide.style.opacity = 0;
                slide.style.zIndex = 0;
                slide.style.height = 0;
                slide.style.pointerEvents = 'none';
            }
        });


        const currentSlide = slides[index];
        const newColor = currentSlide.dataset.color;
        if (newColor) {
            slider.closest('.announcement-bar').style.backgroundColor = newColor;
        }
    }


    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        updateSlides(currentIndex);
    }

    function prevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateSlides(currentIndex);
    }

    nextBtn?.addEventListener('click', nextSlide);
    prevBtn?.addEventListener('click', prevSlide);

    let autoSlide = setInterval(nextSlide, autoPlayDuration);

    slider.addEventListener('mouseenter', () => clearInterval(autoSlide));
    slider.addEventListener('mouseleave', () => {
        autoSlide = setInterval(nextSlide, autoPlayDuration);
    });

    window.addEventListener('resize', () => {
        let newMaxHeight = 0;
        slides.forEach((slide) => {
            const slideHeight = slide.querySelector('.announcement-bar__message').scrollHeight;
            if (slideHeight > newMaxHeight) newMaxHeight = slideHeight;
        });
        slider.style.height = newMaxHeight + 'px';
    });

    updateSlides(currentIndex);
});

